module.exports = __webpack_public_path__ + "static/img/11.603a514.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/4/zh/11.png
// module id = 0CVk
// module chunks = 0